import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-import_template",
  "use": "icon-import_template-usage",
  "viewBox": "0 0 341 46",
  "content": "<symbol viewBox=\"0 0 341 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-import_template\">\n<rect width=\"32.9824\" height=\"46\" rx=\"2\" fill=\"#E5E6EB\" />\n<rect x=\"42.9824\" width=\"101.704\" height=\"12\" rx=\"2\" fill=\"#E5E6EB\" />\n<rect x=\"42.9824\" y=\"18\" width=\"52.7129\" height=\"12\" rx=\"2\" fill=\"#E5E6EB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/import_template.svg
// module id = qThE
// module chunks = 262